<div class="flex flex-col h-screen">

<!-- Header -->
<app-header class="flex-shrink-0"></app-header>

<div class="h-screen w-full pt-0 p-2 overflow-hidden flex flex-col">

  <!-- Main content area -->
  <div class="flex-1 w-full overflow-auto flex">
  <div class="flex flex-col flex-1 bg-white dark:bg-indigo-custom overflow-auto rounded-tr-xl rounded-xl transition-[margin,width] duration-300 ease-in-out pb-2">

    <!-- Header area with mobile menu button - conditionally visible -->
    <div  class="flex justify-between items-center bg-gray-50 dark:bg-secondary-800 rounded-xl px-6 py-3 h-20 p-6 m-3 lg:m-6">

      <div>
        <h1 class="text-lg font-semibold text-secondary dark:text-primary-100 leading-tight">Account Setup</h1>
      </div>

    </div>

    <div class="flex-1 overflow-auto custom-scroll">

      <div class="bg-white dark:bg-indigo-custom">

        <form [formGroup]="form" (submit)="submitForm()" method="POST">
          <fieldset [disabled]="isLoading" class="space-y-6 lg:px-72">

            <!-- Step 1 -->
            <section *ngIf="step === 1">

              <div class="grid grid-cols-12 gap-6">

                <!-- LinkedIn URL -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="LinkedIn URL"
                    placeholder="Add your linkedin url"
                    controlName="linkedin_url"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- Job title -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Job title"
                    placeholder="What is your job title?"
                    controlName="job_title"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- What I actually do -->
                <div class="col-span-12 md:col-span-12">

                  <!--
                  <app-input-field
                    label="What I actually do"
                    placeholder="Describe in simple terms what your day to day job is"
                    controlName="what_i_actually_do"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'We would like to understand if you are doing any specialized sales job, if you are a generalist sales person, or if you do something else.  (i.e. your job is in prospecting, do set-up meetings for executives, you do end-to-end sales for mid-market, you are an account executive for large accounts, or maybe you are an owner/founder doing business development for your company, or you have another use case that you can share with SalesOMMO to make sure we improve how we do our job for you)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>
                  -->

                  <app-dropdown-select
                    label="What I actually do"
                    controlName="actual_duty_id"
                    [required]="true"
                    [options]="actualDuties"
                    placeholder="Select what I actually do"
                    [tooltip]="'We would like to understand if you are doing any specialized sales job, if you are a generalist sales person, or if you do something else. (i.e. your job is in prospecting, do set-up meetings for executives, you do end-to-end sales for mid-market, you are an account executive for large accounts, or maybe you are an owner/founder doing business development for your company, or you have another use case that you can share with SalesOMMO to make sure we improve how we do our job for you)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-dropdown-select>

                </div>

                <!-- Company size -->
                <div class="col-span-12 md:col-span-12">

                  <app-dropdown-select
                    label="Company size"
                    controlName="company_size_id"
                    [required]="true"
                    [options]="companySizes"
                    placeholder="Select company size"
                  ></app-dropdown-select>

                </div>

                <!-- Industry -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="industries && industries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Industry'"
                      [controlName]="'industry_ids'"
                      [options]="industries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleIndustrySelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- What is my main challenge that SaleOMMO can help me tackle? -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="What is my main challenge that SaleOMMO can help me tackle"
                    placeholder="How do you expect SalesOMMO to help you?"
                    controlName="what_is_my_main_challenge"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'We would like to understand what is the main challenge that you have in order to improve how we fine-tune our performance and optimize what SalesOMMO can do for you. (i.e. – your main challenge is to find time to prepare the meetings, to find relevant information, to understand if the organizations fit your target profile, to reduce the time you spend with some prospects that are not marketing-qualified, or similar – please provide the details)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>
                -->

                <!-- What solutions do I sell -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="What solutions do I sell"
                    placeholder="How do you expect SalesOMMO to help you?"
                    controlName="what_solutions_do_i_sell"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'We would like to understand what solutions or products you sell in order to improve how we fine-tune our performance and optimize what SalesOMMO can do for you. (i.e. – if you sell products like servers or notebooks, if you sell software solutions like CRM, ERP, management software for small companies, accountancy software, or other category – please provide the details about what you sell)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>

                <!-- How I help my customers -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="How I help my customers"
                    placeholder="Please provide some details about your product/solutions that creates value to your customers."
                    controlName="how_i_help_my_customers"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'We would like to understand how the solutions or products that you sell add value for your customers in order to improve how we fine-tune our performance and optimize what SalesOMMO can do for you. (i.e. – with the hardware or software that I sell my customers can get scale above the current limits, the management solutions I sell can help customers improve the efficiency with 30% and reduce stocks, the mobile app I sell improve collaboration and optimize the workload for the field workers etc – please provide some details about how what value your customers get and how)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Minimum value of product or services sold"
                    placeholder="e.g. 50M"
                    controlName="min_value_sold"
                    [required]="false"
                    [maxlength]="20"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Maximum value of product or services sold"
                    placeholder="e.g. 500M"
                    controlName="max_value_sold"
                    [required]="false"
                    [maxlength]="20"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!-- Further developments -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Further developments"
                    placeholder="Further developments of my products / solutions"
                    controlName="further_developments"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>
                -->

              </div>

              <!-- Change step -->
              <div class="flex justify-center space-x-6 mt-9">
                <button type="button" (click)="changeStep(2)" class="btn btn-blue">
                  Next step
                </button>
              </div>

            </section>
            <!-- End of step 1 -->

            <!-- Step 2 -->
            <section *ngIf="step === 2">

              <div class="grid grid-cols-12 gap-6">

                <!-- Company size -->
                <div class="col-span-12 md:col-span-6">

                  <div *ngIf="customerCompanySizes && customerCompanySizes.length > 0">
                    <app-combobox-multiselect
                      [label]="'Company size'"
                      [controlName]="'customer_company_size_ids'"
                      [options]="customerCompanySizes"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCustomerCompanySizeSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- Company revenue range -->
                <div class="col-span-12 md:col-span-6">

                  <div *ngIf="companyRevenues && companyRevenues.length > 0">
                    <app-combobox-multiselect
                      [label]="'Company revenue'"
                      [controlName]="'company_revenue_ids'"
                      [options]="companyRevenues"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCompanyRevenueSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- Industry -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="industries && industries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Industry'"
                      [controlName]="'customer_industry_ids'"
                      [options]="customerIndustries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="true"
                      [maxSelection]="10"
                      (selectionChange)="handleCustomerIndustrySelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- What pains/challenges I solve -->
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="What pains/challenges I solve"
                    placeholder="What are the main challenges that my customer face and how my product fulfill them?"
                    controlName="challenges_solved"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'We would like to understand what challenges your customers potentially have in order to improve the probability that SalesOMMO can identify such challenges and get insights about them from the data we research. (i.e. my customers have performance problems and our product enable them scale better, our customers have difficulties retaining people and our solution help them improve engagement, our solutions help my customers reduce costs, or my product helps my customer control better the issues in a particular area – please provide the details about the pains they have and how they can solve them)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>

                <!-- Buying Cycle -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-dropdown-select
                    label="Buying Cycle"
                    placeholder="Select buying cycle"
                    controlName="buying_cycle_id"
                    [required]="true"
                    [options]="buyingCycles"
                    [tooltip]="'We would like to understand if most of the customers you talk to are do not know they have a pain, if they already are aware about the problem you can help them tackle, if they are already actively researching for a solution, already evaluating multiple product and solutions, or if they have a standard budget and are looking for vendors to comply with the requirements that fit the budget.'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-dropdown-select>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Company profitability"
                    placeholder="What is the profitability of your customer company?"
                    controlName="company_profitability"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Number of locations"
                    placeholder="What is the location number of your customer company?"
                    controlName="location_numbers"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'number'"
                  ></app-input-field>

                </div>
                -->

                <!-- Target Countries -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="countries && countries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Target countries'"
                      [controlName]="'target_country_ids'"
                      [options]="countries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="false"
                      [maxSelection]="5"
                      (selectionChange)="handleTargetCountrySelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

                <!-- Trend 1 -->
                <div class="col-span-12 md:col-span-6">

                  <app-dropdown-select
                    label="Trend 1 - Number of employees"
                    placeholder="Select trend employee"
                    controlName="trend_employee_id"
                    [required]="true"
                    [options]="trendEmployees"
                  ></app-dropdown-select>

                </div>

                <!-- Trend 2 -->
                <div class="col-span-12 md:col-span-6">

                  <app-dropdown-select
                    label="Trend 2 - Revenue"
                    placeholder="Select rend revenue"
                    controlName="trend_revenue_id"
                    [required]="true"
                    [options]="trendRevenues"
                  ></app-dropdown-select>

                </div>

                <!-- Other Criteria -->
                <!--
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Other criteria"
                    placeholder="Define more information about the criteria to select customers."
                    controlName="other_criteria"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>
                -->

                <!-- Open Jobs -->
                <!--
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Open jobs"
                    placeholder="If your prospects have open jobs, what information would be relevant in order for you to select customers to target."
                    controlName="open_jobs"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                    [tooltip]="'Please provide us what information would be useful for you to select customers to target from the information provided in job descriptions (i.e. – certain technologies used, specific job titles that are recruited, other specific requirements such as working remote, hybrid, or on-site for most of the jobs etc)'"
                    [tooltipPosition]="'right'"
                    [tooltipClass]="'custom-tooltip'"
                  ></app-input-field>

                </div>
                -->

                <div class="col-span-12">
                  <div class="border-b border-gray-300 my-3"></div>
                </div>

                <!-- Main user role department -->
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Main user role department"
                    placeholder="Input your department name"
                    controlName="main_user_department_role"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- Main user role -->
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Main user role"
                    placeholder="Input your main user role"
                    controlName="main_user_role"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- Main buyer department -->
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Main buyer department"
                    placeholder="Input your main user role"
                    controlName="main_buyer_department"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- Main buyer job title -->
                <div class="col-span-12 md:col-span-6">

                  <app-input-field
                    label="Main buyer job title"
                    placeholder="Input your main buyer job title"
                    controlName="main_buyer_job_title"
                    [required]="true"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>

                <!-- My closed deal are typical -->
                <div class="col-span-12 md:col-span-12">

                  <app-dropdown-select
                    label="My closed deal are typical"
                    placeholder="Select closed deal"
                    controlName="close_deal_id"
                    [required]="true"
                    [options]="closedDeals"
                  ></app-dropdown-select>

                </div>

                <!-- Other departments involved -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Other departments involved"
                    placeholder="Other departments involved"
                    controlName="other_departments"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>
                -->

                <!-- Other people involved -->
                <!--
                <div class="col-span-12 md:col-span-12">

                  <app-input-field
                    label="Other people involved"
                    placeholder="Other people involved"
                    controlName="other_people"
                    [required]="false"
                    [maxlength]="255"
                    [type]="'text'"
                  ></app-input-field>

                </div>
                -->

                <!-- Exclusion list -->
                <div class="col-span-12 md:col-span-12">

                  <div *ngIf="countries && countries.length > 0">
                    <app-combobox-multiselect
                      [label]="'Country exclusion list'"
                      [controlName]="'country_exclusion_ids'"
                      [options]="countries"
                      [displayKey]="'name'"
                      [valueKey]="'id'"
                      [required]="false"
                      [maxSelection]="5"
                      (selectionChange)="handleCountryExclusionListSelectionChange($event)"
                    ></app-combobox-multiselect>
                  </div>

                </div>

              </div>

              <!-- Change step -->
              <div class="flex justify-center space-x-6 mt-9">
                <button type="button" (click)="changeStep(1)" class="btn btn-cancel">
                  Previous step
                </button>

                <button type="submit" class="btn btn-blue">
                  Update information
                </button>
              </div>

            </section>
            <!-- End of step 2 -->

          </fieldset>
        </form>
      </div>
    </div>

  </div>
  </div>

</div>

</div>
